import { DEFAULT_COUNTRY_CODE } from 'lib/constants/siteDefaults';
import { CountryCode } from 'services/shopify';

export const convertToCountryCodeEnum = (value: string): CountryCode => {
  const countryCodeValues = Object.values(CountryCode);

  if (countryCodeValues.includes(value as CountryCode)) {
    return value as CountryCode;
  }

  return DEFAULT_COUNTRY_CODE as CountryCode;
};
